import {PasswordValidationErrors} from 'src/constans/validation';

export const DataAutotestAttributes = {
  [PasswordValidationErrors.Uppercase]: 'capital-letter',
  [PasswordValidationErrors.Lowercase]: 'small-letter',
  [PasswordValidationErrors.Characters]: '8-characters',
  [PasswordValidationErrors.NumberOrSymbol]: 'one-number',
}
